export default function getEnvironment() {
    return process.env.NODE_ENV;
}
